import { render, staticRenderFns } from "./AboutLessonStatus.vue?vue&type=template&id=35c33900&scoped=true&"
import script from "./AboutLessonStatus.vue?vue&type=script&lang=js&"
export * from "./AboutLessonStatus.vue?vue&type=script&lang=js&"
import style0 from "./AboutLessonStatus.vue?vue&type=style&index=0&id=35c33900&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c33900",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
